import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
// OBSERVABILITY-S1 — Sentry init + ErrorBoundary global.
// Dynamic-aware: noop em dev local sem a lib; em prod (Vercel build
// instala @sentry/react do package.json) + REACT_APP_SENTRY_DSN no
// env inicializa e captura erros com PII scrubbed.
import { initSentry, SentryBoundary } from "@/utils/sentryInit";
import { registerServiceWorker } from "@/utils/registerServiceWorker";

// Fire-and-forget — init async não bloqueia render.
initSentry().catch(() => { /* */ });

// C1 — PWA: registra o service worker SÓ em produção. Em dev o SW
// atrapalha hot reload e serve bundle velho do cache.
if (process.env.NODE_ENV === "production") {
  registerServiceWorker();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SentryBoundary>
      <App />
    </SentryBoundary>
  </React.StrictMode>,
);
